import {
  ThemeUICSSObject,
  getColorsByPath,
  responsive,
  spacing,
} from '@apia/theme';

const gridCols = responsive({
  0: 'repeat(1, 1fr)',
  3: 'repeat(2, 1fr)',
  5: 'repeat(3, 1fr)',
});

const spanAll = responsive({
  0: 'span 1',
  3: 'span 2',
  5: 'span 4',
});

const spanHalf = responsive({
  0: 'span 1',
  5: 'span 2',
});

const decAdmGlobal: ThemeUICSSObject = {
  upsertion: {
    '.content': {
      '& > div:first-of-type': {
        padding: '32px',
        display: 'flex',
        flexDirection: 'column',
        gap: '24px',
      },
    },
    fieldset: {
      display: 'grid',
      gridTemplateColumns: gridCols,
      p: '0px !important',
      '&.notGrid': {
        display: 'block',
      },

      gap: spacing(4),
      border: 'none',
      ...getColorsByPath('tab'),

      '.flagContainer': {
        gridColumn: spanHalf,
        display: 'grid',
        flexDirection: 'column',
        alignItems: 'center',
        gap: spacing(4),
      },

      '.checkbox': {
        flexDirection: 'row-reverse',
        alignItems: 'center',
        justifyContent: 'start',
        gap: spacing(4),
        '.semicolon': {
          display: 'none',
        },
      },
      '.fieldWrapper.imageSelector': {
        width: 'fit-content',
      },
      '.imageSelector': {
        gridColumn: spanHalf,
        alignItems: 'center',
        '.buttonContainer': {
          gridColumn: spanHalf,
          alignSelf: 'center',
          '&>div': { gap: spacing(0) },

          position: 'relative',
          '.deleteImage': {
            position: 'absolute',
            right: 0,
            top: 0,
            color: 'palette.text.primary',
            backgroundColor: 'palette.background.paper',
            borderRadius: '100%',
            p: '4px',
          },
          '.imageContainer': {
            p: spacing(4),
          },
        },
      },

      '.textarea': {
        textarea: {
          height: '15vh',
          mt: spacing(1),
        },
      },

      '.fldSpanAll': {
        gridColumn: spanAll,
      },

      '.fldSpanHalf': {
        gridColumn: spanHalf,
      },

      '& label': {
        alignItems: 'stretch',
      },
    },
  },
};

export default decAdmGlobal;
